
let _ = require("lodash");
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  components: {
    // VueImageLightbox: () => import('vue-image-lightbox'),
    CoolLightBox: () => import("vue-cool-lightbox"),
    SearchIcon: () => import("~/assets/svg/heroicons/search.svg?inline"),
    PlayIcon: () => import("~/assets/svg/heroicons/play.svg?inline"),
    PlayVideoIcon: () => import("~/assets/svg/heroicons/play-video.svg?inline"),
    FullScreenIcon: () =>
      import("~/assets/svg/heroicons/fullscreen-line.svg?inline"),
    SettingIcon: () => import("~/assets/svg/heroicons/setting.svg?inline"),
    VolumeUpIcon: () => import("~/assets/svg/heroicons/volume-up.svg?inline"),
    PauseIcon: () =>
      import("~/assets/svg/heroicons/pause-mini-line.svg?inline"),
    MuteIcon: () => import("~/assets/svg/heroicons/mute.svg?inline"),
    AngleLeftSwitchIcon: () =>
      import("~/assets/svg/heroicons/angle-left-switch.svg?inline"),
    AngleRightSwitchIcon: () =>
      import("~/assets/svg/heroicons/angle-right-switch.svg?inline"),
  },
  data() {
    return {
      folderName: "/screen-1440",
      controls: false,
      lightboxIndex: null,
      lightboxImages: [],
      isVideo: false,
      isMore: false,
      controller: null,
      media: [],
      mediaLightBox: [],
    };
  },
  computed: {
    gallery() {
      return [
        `/about-us/gallery/1.png`,
        `/about-us/gallery/3.png`,
        `/about-us/gallery/18.png`,
        `/about-us/gallery/4.png`,
        `/about-us/gallery/5.png`,
        `/about-us/gallery/6.png`,
        `/about-us/gallery/7.png`,
        `/about-us/gallery/8.png`,
        `/about-us/gallery/9.png`,
        `/about-us/gallery/10.png`,
        `/about-us/gallery/11.png`,
        `/about-us/gallery/12.png`,
        `/about-us/gallery/13.png`,
        `/about-us/gallery/14.png`,
        `/about-us/gallery/15.png`,
        `/about-us/gallery/16.png`,
        `/about-us/gallery/17.png`,
        `/about-us/gallery/2.png`,
        `/about-us/gallery/19.png`,
        `/about-us/gallery/20.png`,
      ];
    },
    videoGallery() {
      const isTornado =
        this.$store.state.country != "it"
          ? [`${this.$config.CDN_DOMAIN}/gallery/TNT2024.mp4`]
          : [];
      return [
        `/about-us/gallery/1.png`,
        `/about-us/gallery/3.png`,
        `/about-us/gallery/18.png`,
        `/about-us/gallery/4.png`,
        `/about-us/gallery/5.png`,
        `/about-us/gallery/6.png`,
        `/about-us/gallery/7.png`,
        `/about-us/gallery/8.png`,
        `/about-us/gallery/9.png`,
        `/about-us/gallery/10.png`,
        `/about-us/gallery/11.png`,
        `/about-us/gallery/12.png`,
        `/about-us/gallery/13.png`,
        `/about-us/gallery/14.png`,
        `/about-us/gallery/15.png`,
        `/about-us/gallery/16.png`,
        `/about-us/gallery/17.png`,
        `/about-us/gallery/2.png`,
        `/about-us/gallery/19.png`,
        `/about-us/gallery/20.png`,
        `${this.$config.CDN_DOMAIN}/gallery/LEO8002024.mp4`,
        `${this.$config.CDN_DOMAIN}/gallery/Leo2024.mp4`,
        `${this.$config.CDN_DOMAIN}/gallery/TRK-702X-2023.mp4`,
        ...isTornado,
      ];
    },
  },
  mounted() {
    if (process.browser) {
      if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.folderName = "/screen-768";
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        this.folderName = "/screen-1024";
      } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        this.folderName = "/screen-1440";
      } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
        this.folderName = "/screen-1920";
      } else if (window.innerWidth >= 2500) {
        this.folderName = "/screen-2500";
      } else {
        this.folderName = "/screen-375";
      }

      window.addEventListener("resize", this.onResize);
    }
  },
  methods: {
    countryWiseClass(defaultClass = "") {
      return this.$store.state.country == "it" ? "h-auto" : defaultClass;
    },
    openLightbox(index, isVideo) {
      this.lightboxIndex = index;
      this.isVideo = isVideo;
    },
    onChangeLightbox(index) {
      var videoControls = document.getElementById("video-controls");
      var video = document.querySelector(".aboutus-gallary video");
      var progress = document.getElementById("progress");
      var remainingTime = document.getElementById("remaining-time");
      var progressDot = document.getElementById("progress-dot");
      var progressBar = document.getElementById("progress-bar");

      if (progressBar) {
        progressBar.style.width = "0%";
      }
      if (progressDot) {
        progressDot.onmousedown = null;
        const progressDotHalflWidth = progressDot.offsetWidth / 2;
        progressDot.style.left = -progressDotHalflWidth + "px";
        progressDot.value = 0;
      }
      if (videoControls) {
        videoControls.style.display = "none";
      }

      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }

      if (remainingTime) {
        remainingTime.innerHTML = "00:00";
      }
      if (video) {
        video.currentTime = 0;
      }
      if (progress) {
        progress.value = 0;
        progress.setAttribute("max", 0);
      }

      let videoGallery = this.videoGallery.find((_v, _i) => _i === index);
      let isVideo = false;

      if (videoGallery && videoGallery.includes("mp4")) {
        isVideo = true;
      } else {
        var videoControls = document.getElementById("video-controls");
        videoControls.style.display = "none";
      }

      if (!isVideo) return false;

      setTimeout(() => {
        this.updateCustomVideo();
      }, 400);
    },
    onOpenLightbox(index) {
      let videoGallery = this.videoGallery.find((_v, _i) => _i === index);
      let isVideo = false;

      if (videoGallery && videoGallery.includes("mp4")) {
        isVideo = true;
      } else {
        var videoControls = document.getElementById("video-controls");
        videoControls.style.display = "none";
      }

      if (!isVideo) return false;

      setTimeout(() => {
        this.updateCustomVideo(true);
      }, 400);
    },
    updateCustomVideo(directPlay = false) {
      // Does the browser actually support the video element?
      var supportsVideo = !!document.createElement("video").canPlayType;

      if (supportsVideo) {
        var videoContainer =
          document.getElementsByClassName("cool-lightbox")[0];
        var video = document.querySelector(".aboutus-gallary video");

        var videoControls = document.getElementById("video-controls");

        // Hide the default controls
        video.controls = false;

        // Display the user defined video controls
        videoControls.style.display = "flex";

        // Obtain handles to buttons and other elements
        var fullscreenPreview = document.getElementById("fullscreen-preview");
        var playpause = document.getElementById("playpause");
        var stop = document.getElementById("stop");
        var mute = document.getElementById("mute");
        var volinc = document.getElementById("volinc");
        // var voldec = document.getElementById('voldec');
        var progress = document.getElementById("progress");
        var progressBar = document.getElementById("progress-bar");
        var progressDot = document.getElementById("progress-dot");
        var remainingTime = document.getElementById("remaining-time");
        var fullscreen = document.getElementById("fs");

        if (directPlay) {
          stop.style.display = "block";
          playpause.style.display = "none";
          video.play();
        } else {
          stop.style.display = "none";
          playpause.style.display = "flex";
        }

        volinc.style.display = "block";
        mute.style.display = "none";
        video.muted = false;

        // Set the video container's fullscreen state
        var setRemainingTime = function () {
          // Get the video duration in seconds
          const duration = video.duration;

          // Calculate the remaining time in seconds
          const remaining = duration - video.currentTime;

          if (!remaining) {
            playpause.style.display = "flex";
            stop.style.display = "none";
          }

          // Convert the remaining time to minutes and seconds
          let minutes = Math.floor(remaining / 60);
          const seconds = Math.floor(remaining % 60);

          // Convert the remaining time to hours and minutes
          // const hours = Math.floor(minutes / 60);
          minutes = minutes % 60;

          remainingTime.innerHTML = `-${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        };

        this.controller = new AbortController();

        // Check if the browser supports the Fullscreen API
        var fullScreenEnabled = !!(
          document.fullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.msFullscreenEnabled ||
          document.webkitSupportsFullscreen ||
          document.webkitFullscreenEnabled ||
          document.createElement("video").webkitRequestFullScreen
        );
        // If the browser doesn't support the Fulscreen API then hide the fullscreen button
        if (!fullScreenEnabled) {
          fullscreen.style.display = "none";
        }

        // Set the video container's fullscreen state
        var setFullscreenData = function (state) {
          fullscreenPreview.setAttribute("data-fullscreen", !!state);
          if (state) {
            // stop.style.display = 'block';
            // volinc.style.display = 'block';
            // videoControls.style.display = 'flex';
          } else {
            // stop.style.display = 'block';
            // volinc.style.display = 'block';
          }
        };

        // Checks if the document is currently in fullscreen mode
        var isFullScreen = function () {
          return !!(
            document.fullScreen ||
            document.webkitIsFullScreen ||
            document.mozFullScreen ||
            document.msFullscreenElement ||
            document.fullscreenElement
          );
        };

        // Fullscreen
        var handleFullscreen = function () {
          // If fullscreen mode is active...
          if (isFullScreen()) {
            // ...exit fullscreen mode
            // (Note: this can only be called on document)
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.mozCancelFullScreen)
              document.mozCancelFullScreen();
            else if (document.webkitCancelFullScreen)
              document.webkitCancelFullScreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
            setFullscreenData(false);
          } else {
            // ...otherwise enter fullscreen mode
            // (Note: can be called on document, but here the specific element is used as it will also ensure that the element's children, e.g. the custom controls, go fullscreen also)
            if (fullscreenPreview.requestFullscreen)
              fullscreenPreview.requestFullscreen();
            else if (fullscreenPreview.mozRequestFullScreen)
              fullscreenPreview.mozRequestFullScreen();
            else if (fullscreenPreview.webkitRequestFullScreen) {
              // Safari 5.1 only allows proper fullscreen on the video element. This also works fine on other WebKit browsers as the following CSS (set in styles.css) hides the default controls that appear again, and
              // ensures that our custom controls are visible:
              // figure[data-fullscreen=true] video::-webkit-media-controls { display:none !important; }
              // figure[data-fullscreen=true] .controls { z-index:2147483647; }
              videoContainer.webkitRequestFullScreen();
            } else if (fullscreenPreview.msRequestFullscreen)
              fullscreenPreview.msRequestFullscreen();
            setFullscreenData(true);
          }
        };

        // Only add the events if addEventListener is supported (IE8 and less don't support it, but that will use Flash anyway)
        if (document.addEventListener) {
          // Wait for the video's meta data to be loaded, then set the progress bar's max value to the duration of the video
          video.addEventListener(
            "loadedmetadata",
            function () {
              progress.setAttribute("max", video.duration);
              setRemainingTime();
            },
            { signal: this.controller.signal }
          );

          // Add events for all buttons
          playpause.addEventListener(
            "click",
            function (e) {
              if (video.paused || video.ended) {
                video.play();
                playpause.style.display = "none";
                stop.style.display = "block";
              }
            },
            { signal: this.controller.signal }
          );

          stop.addEventListener(
            "click",
            function (e) {
              video.pause();
              playpause.style.display = "flex";
              stop.style.display = "none";
              // video.currentTime = 0;
              // progress.value = 0;
            },
            { signal: this.controller.signal }
          );
          mute.addEventListener(
            "click",
            function (e) {
              video.muted = false;
              mute.style.display = "none";
              volinc.style.display = "block";
            },
            { signal: this.controller.signal }
          );
          volinc.addEventListener(
            "click",
            function (e) {
              // alterVolume('+');
              video.muted = true;
              volinc.style.display = "none";
              mute.style.display = "block";
            },
            { signal: this.controller.signal }
          );
          // voldec.addEventListener('click', function(e) {
          //   alterVolume('-');
          // });
          fullscreen.addEventListener(
            "click",
            function (e) {
              handleFullscreen();
            },
            { signal: this.controller.signal }
          );

          // As the video is playing, update the progress bar
          video.addEventListener(
            "timeupdate",
            function () {
              // For mobile browsers, ensure that the progress element's max attribute is set
              if (
                !progress.getAttribute("max") ||
                progress.getAttribute("max") <= 0
              ) {
                progress.setAttribute("max", video.duration);
              }
              progress.value = video.currentTime;
              progressBar.style.width =
                (video.currentTime / video.duration) * 100 + "%";
              progressDot.style.left =
                "calc(" +
                (video.currentTime / video.duration) * 100 +
                "% - " +
                progressDot.offsetWidth / 2 +
                "px)";
              setRemainingTime();
            },
            { signal: this.controller.signal }
          );

          // React to the user clicking within the progress bar

          progress.addEventListener(
            "click",
            function (e) {
              const pos =
                (e.pageX -
                  progress.offsetLeft -
                  progress.offsetParent.offsetLeft -
                  30) /
                progress.offsetWidth;

              video.currentTime = pos * video.duration;
            },
            { signal: this.controller.signal }
          );

          this.progressDotHandler(video, progressDot, progress);

          // Listen for fullscreen change events (from other controls, e.g. right clicking on the video itself)
          document.addEventListener(
            "fullscreenchange",
            function (e) {
              setFullscreenData(
                !!(document.fullScreen || document.fullscreenElement)
              );
            },
            { signal: this.controller.signal }
          );
          document.addEventListener(
            "webkitfullscreenchange",
            function () {
              setFullscreenData(!!document.webkitIsFullScreen);
            },
            { signal: this.controller.signal }
          );
          document.addEventListener(
            "mozfullscreenchange",
            function () {
              setFullscreenData(!!document.mozFullScreen);
            },
            { signal: this.controller.signal }
          );
          document.addEventListener(
            "msfullscreenchange",
            function () {
              setFullscreenData(!!document.msFullscreenElement);
            },
            { signal: this.controller.signal }
          );
        }
      }
    },
    progressDotHandler(video, progressDot, progress) {
      progressDot.onmousedown = function (event) {
        function moveAt(pageX) {
          const progressDotHalflWidth = progressDot.offsetWidth / 2;
          const progressOffset = progress.offsetWidth - progressDotHalflWidth;
          const pageOffeset = pageX - progressDot.offsetWidth - 128;
          if (
            progressOffset >= pageOffeset &&
            pageOffeset >= -progressDotHalflWidth
          ) {
            progressDot.style.left = pageOffeset + "px";
          }
        }

        moveAt(event.pageX);

        function onMouseMove(event) {
          moveAt(event.pageX);
        }

        function onMouseUp(e) {
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("mouseup", onMouseUp);

          const pos =
            (e.pageX -
              progress.offsetLeft -
              progress.offsetParent.offsetLeft -
              23) /
            progress.offsetWidth;

          video.currentTime = pos * video.duration;
          progressDot.onmouseup = null;
        }

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };
      progressDot.ondragstart = function () {
        return false;
      };
    },
    closeLightbox(index) {
      this.lightboxIndex = null;

      let videoGallery = this.videoGallery.find((_v, _i) => _i === index);
      let isVideo = false;

      if (videoGallery && videoGallery.includes("mp4")) {
        isVideo = true;
      }

      if (!isVideo) return false;

      var videoControls = document.getElementById("video-controls");
      var video = document.querySelector(".aboutus-gallary video");
      var progress = document.getElementById("progress");
      var remainingTime = document.getElementById("remaining-time");
      var progressDot = document.getElementById("progress-dot");

      progressDot.onmousedown = null;
      videoControls.style.display = "none";

      this.controller.abort();
      this.controller = null;

      remainingTime.innerHTML = "00:00";
      video.currentTime = 0;
      progress.value = 0;
      progress.setAttribute("max", 0);
      const progressDotHalflWidth = progressDot.offsetWidth / 2;
      progressDot.style.left = -progressDotHalflWidth + "px";
      progressDot.value = 0;
    },
    showVideoControls() {
      this.controls = true;
    },
    hideVideoControls() {
      this.controls = false;
    },
    onResize() {
      if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.folderName = "/screen-768";
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        this.folderName = "/screen-1024";
      } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        this.folderName = "/screen-1440";
      } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
        this.folderName = "/screen-1920";
      } else if (window.innerWidth >= 2500) {
        this.folderName = "/screen-2500";
      } else {
        this.folderName = "/screen-375";
      }
    },
  },
  head() {
    return {
      title: this.$t("common.about_us"),
    };
  },
};
